import React, { createContext, useContext, useState } from "react";

// `ready` flips to true as the intro loader starts lifting, so entrance animations play on reveal.
const IntroContext = createContext({ ready: true, setReady: () => {} });

export const IntroProvider = ({ children }) => {
  const [ready, setReady] = useState(false);
  return <IntroContext.Provider value={{ ready, setReady }}>{children}</IntroContext.Provider>;
};

export const useIntro = () => useContext(IntroContext);
